import { mapGetters, mapActions } from 'vuex'
import { getDateNowUnix } from '@/utils/dateHelpers'

import TableList from '@/components/TableList/index'

export default {
  components: {
    TableList
  },
  data: () => ({
    newGroupName: '',
    groups: null,
    groupMenu: false,
    x: 0,
    y: 0,
    selectedGroupId: 0,
    groupPanel: [],
    headerArr: ['Rank', 'Name', 'Pts', 'Avg.', 'Total', ''],
    editGroupToggle: false,
    canEditGroup: false
  }),
  computed: {
    ...mapGetters('profile', ['GROUP_ARR']),
    ...mapGetters('auth', ['USER_OBJ']),
    ...mapGetters(['SELECTED_GROUP_INDEX']),
    inviteLink() {
      return `/invite-friend/${this.selectedGroupId}`
    }
  },
  methods: {
    ...mapActions('profile', {
      fetchMyGroupAction: 'FETCH_MYGROUP'
    }),
    ...mapActions('player', {
      changeGroupName: 'CHANGE_GROUP_NAME'
    }),
    toggleEditGroup() {
      this.editGroupToggle = !this.editGroupToggle
    },
    async saveNewName() {
      const payload = {
        groupId: this.selectedGroupId,
        groupName: this.newGroupName
      }
      await this.changeGroupName(payload)
      const groupIndex = this.GROUP_ARR.findIndex(
        x => x.id === this.selectedGroupId
      )
      this.GROUP_ARR[groupIndex].groupName = this.newGroupName
      this.toggleEditGroup()
    },
    groupMenuClicked(groupId, e) {
      e.stopPropagation()
      this.x = e.clientX - 50
      this.y = e.clientY + 10
      this.groupMenu = true

      const groupIndex = this.GROUP_ARR.findIndex(x => x.id === groupId)

      this.canEditGroup = this.GROUP_ARR[groupIndex].admin
      this.selectedGroupId = groupId
    },
    rankDrawCheck(allUsers, rankNo) {
      const drawLength = allUsers.filter(user => user.rank === rankNo)
      return drawLength.length > 1
    },
    mapUsers(data) {
      return data.currentRank.map(user => {
        const {
          id,
          username,
          avatar,
          total,
          roundCount,
          rank,
          points: currentRoundPoints
        } = user
        const prevRankIndex = data.prevRank
          ? data.prevRank.findIndex(item => item.id === id)
          : data.currentRank

        const parsedRoundCount = parseInt(roundCount) - 1
        const totalPoints = total || 0
        const startRound = this.startRound(
          parseInt(this.GROUP_ARR[0].currentRoundStart.event_timestamp)
        )
        const points =
          !startRound && data.prevRank
            ? data.prevRank[prevRankIndex].lastWeekTotalPoints
            : prevRankIndex >= 0
            ? total - data.prevRank[prevRankIndex].total
            : currentRoundPoints
        const rankDraw = this.rankDrawCheck(data.currentRank, rank)

        return {
          id,
          rank: rank,
          name: `${username}`,
          avatar,
          points,
          average:
            parsedRoundCount > 0 && prevRankIndex >= 0
              ? data.prevRank[prevRankIndex].total / parsedRoundCount
              : 0,
          total: totalPoints,
          rankStatus:
            prevRankIndex >= 0
              ? parseInt(data.prevRank[prevRankIndex].rank) - parseInt(rank)
              : 0,
          roundCount,
          rankDraw
        }
      })
    },
    groupPanelChecker(data) {
      if (data) {
        return data[0]
      }
      return true
    },
    startRound(startTime) {
      const dateNow = getDateNowUnix()
      return dateNow >= startTime
    }
  },
  activated() {
    this.fetchMyGroupAction().then(() => {
      const averageIndex = this.headerArr.findIndex(item => item === 'Avg.')
      const prevRound = this.GROUP_ARR[0].previousRound
      const pointsIndex = this.headerArr.findIndex(item => item === 'Pts')
      const startRound = this.startRound(
        parseInt(this.GROUP_ARR[0].currentRoundStart.event_timestamp)
      )
      if (prevRound) {
        this.headerArr[averageIndex] = `Avg.(R${prevRound})`
        this.headerArr[pointsIndex] = `R${
          startRound ? prevRound + 1 : prevRound
        } Pts`
      } else {
        this.headerArr[averageIndex] = `Avg.(R1)`
        this.headerArr[pointsIndex] = `R1 Pts`
      }
      this.groupPanel = this.GROUP_ARR.map(() => [])
      if (this.SELECTED_GROUP_INDEX !== null && this.groupPanel.length > 0) {
        this.groupPanel[this.SELECTED_GROUP_INDEX][0] = true
      }
    })
  }
}
